module.exports = ".table {\r\n    display: table;\r\n}\r\n\r\n.table-row {\r\n    display: table-row;\r\n}\r\n\r\n.table-cell {\r\n    display: table-cell;\r\n    border: 1px solid #ddd;\r\n    padding: 4px;\r\n}\r\n\r\n.table-header {\r\n    font-weight: bold;\r\n}\r\n\r\n.text {\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n}\r\n\r\n.btn {\r\n    margin-bottom: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/votelocation-list/votelocation-list.component.css
// module id = ./src/app/components/votelocation-list/votelocation-list.component.css
// module chunks = main